import { isEmpty } from "../common/Common";
import I18n from "../common/I18n";
import { Call, ApiUrl, ParseGeneralResponse, PageParams,setObjectToFormData, buildQueryString } from "./ApiUtils";
import AppConfig from "../config/AppConfig";
import userStore from "../stores/UserStore";
import _ from "lodash"
import moment from "moment";
import { message } from "antd";

export function fetchWeekReport(driverId = '', weekNumber = '', yearNumber = '', searchText = '', page = 1, perPage = 5) {
  let url = ApiUrl(`v2/gross_order_reports?operation_code=GOR`);
  if (!isEmpty(weekNumber) && !isEmpty(yearNumber)) {
    url = `${url}&week_number=${weekNumber}&year_number=${yearNumber}`;
  }
  if(!isEmpty(searchText)){
    url = `${url}&customer_order_number=${encodeURIComponent(searchText)}`;
  }
  if(!isEmpty(driverId) && isEmpty(searchText)){
    url = `${url}&driver_id=${driverId}`;
  }
  url = `${url}&page=${page}&perPage=${perPage}`;
  return Call('get', url, {}, ParseGeneralResponse, {
    responseDataKeys: { reports: 'weekly_report', driverPayReports: 'driver_pay_reports', driverDeductions: 'driver_deduction_reports',total_count: 'total_count' },
  });
}

export function fetchDriverPayReport(customerOrderIds = [], driverPayId = '') {
  const url = ApiUrl(`v2/gross_order_reports/driver_pay_order_reports?driver_pay_report_id=${driverPayId}&operation_code=DPOR`);
  return Call('get', url, { customer_order_ids: customerOrderIds }, ParseGeneralResponse, {
    responseDataKeys: { reports: 'weekly_report', claim_balance: 'claim_balance', loan_balance: 'loan_balance', advance_balance: 'advance_balance', driverDeductions: 'driver_deduction_reports' },
  });
}

export function fetchDriverInvoiceDetail(driverPayId = '') {
  const url = ApiUrl(`v2/weekly_drivers_reports/get_driver_invoice_details?driver_pay_report_id=${driverPayId}`);
  return Call('get', url, {}, ParseGeneralResponse, {
    responseDataKeys: { reports: 'driver_report'},
  });
}

export function saveGrossOrdersData(data) {
  const url = ApiUrl('v2/gross_order_reports/update_gross_amount');
  const method = 'put';
  return Call(method, url, data, ParseGeneralResponse, { responseDataKeys: { reports: 'weekly_report', driverPayReports: 'driver_pay_reports', driverDeductions: 'driver_deduction_reports', claim_balance: 'claim_balance', loan_balance: 'loan_balance', advance_balance: 'advance_balance' } });
}

export function saveDriverDeductionData(data) {
  const url = ApiUrl('v2/gross_order_reports/update_driver_deduction_reports');
  const method = 'put';
  return Call(method, url, data, ParseGeneralResponse, { responseDataKeys: { reports: 'weekly_report', driverDeductions: 'driver_deduction_reports', claim_balance: 'claim_balance', loan_balance: 'loan_balance', advance_balance: 'advance_balance' } });
}

export function approveReport(data) {
  const url = ApiUrl('v2/gross_order_reports/update_driver_report_status');
  const method = 'put';
  return Call(method, url, data, ParseGeneralResponse, { responseDataKeys: { reports: 'weekly_report', driverPayReports: 'driver_pay_reports', driverDeductions: 'driver_deduction_reports' , claim_balance: 'claim_balance', loan_balance: 'loan_balance', advance_balance: 'advance_balance'} });
}

export function deleteGrossOrder(data) {
  const url = ApiUrl(`v2/gross_order_reports/delete_gross_order?organization_id=${data.organization_id}&driver_pay_report_id=${data.driver_pay_report_id}&gross_order_id=${data.gross_order_id}`);
  const method = 'get';
  return Call(method, url, {}, ParseGeneralResponse, { responseDataKeys: { reports: 'weekly_report', driverPayReports: 'driver_pay_reports', driverDeductions: 'driver_deduction_reports' , claim_balance: 'claim_balance', loan_balance: 'loan_balance', advance_balance: 'advance_balance'} });
}

export function deleteDeduction(data) {
  const url = ApiUrl(`v2/gross_order_reports/delete_driver_deduction_reports?org_id=${data.org_id}&driver_pay_report_id=${data.driver_pay_report_id}&driver_id=${data.driver_id}&driver_deduction_report_id=${data.driver_deduction_report_id}`);
  const method = 'get';
  return Call(method, url, {}, ParseGeneralResponse, { responseDataKeys: { reports: 'weekly_report', driverPayReports: 'driver_pay_reports', driverDeductions: 'driver_deduction_reports' , claim_balance: 'claim_balance', loan_balance: 'loan_balance', advance_balance: 'advance_balance'} });
}



export function saveReportDetails(data) {
  const url = ApiUrl('v2/gross_order_reports/update_driver_pay_report_details');
  const method = 'put';
  return Call(method, url, data, ParseGeneralResponse, { responseDataKeys: { reports: 'weekly_report', driverPayReports: 'driver_pay_reports', driverDeductions: 'driver_deduction_reports', claim_balance: 'claim_balance', loan_balance: 'loan_balance', advance_balance: 'advance_balance' } });
}
export function addWeekPeriodToDriver(data) {
  const url = ApiUrl('v2/gross_order_reports/add_default_driver_pay_report');
  const method = 'post';
  return Call(method, url, data, ParseGeneralResponse, { responseDataKeys: {  driver_pay_reports: 'driver_pay_report' } });
}

export function emailWeeklyReport(id, payload){
    payload.operation_code = 'WREMAIL'
    const url = ApiUrl(`v2/gross_order_reports/email_driver_pay_invoice`)
    return Call('POST', url, payload, ParseGeneralResponse, {
      responseDataKeys: { data: '' },
    })
}
export function downloadWeeklyReport(id){
    const url = ApiUrl(`v2/gross_order_reports/view_driver_pay_invoice?driver_pay_report_id=${id}`)
    return Call('get', url, { operation_code: 'WRD'}, ParseGeneralResponse, {
      responseDataKeys: {
        report_file: 'driver_pay_invoice',
      },
    })
}

export function fetchAgingReports(
  page = 1,
  perPage = AppConfig.perPage,
  wh_id,
  searchText = "",
  filter = {}
) {
  const org_id = userStore.getStateValue("selectedOrg");
  let url = ApiUrl(
    `v2/billing_aging_reports/get_aging_reports?organization_id=${org_id}&is_export=${false}&${PageParams(
      page,
      perPage
    )}`
  );
  if (!isEmpty(searchText)) {
    url = `${url}&search_value=${searchText}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.sortBy) && !isEmpty(filter.sortByType)) {
    url = `${url}&sort_by=${filter.sortBy}&sort_order=${I18n.t(`general.sort_${filter.sortByType}`)}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.accountCodes) && filter.accountCodes.length > 0) {
    url = `${url}&account_ids=${filter.accountCodes}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.warehouseIds) && filter.warehouseIds.length > 0 && isEmpty(searchText)) {
    url = `${url}&wh_location_id=${filter.warehouseIds}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.fromDate) && !isEmpty(filter.toDate)) {
    const fromDate = moment(filter.fromDate).format("YYYY-MM-DD");
    const toDate = moment(filter.toDate).format("YYYY-MM-DD")
    url = `${url}&from_date=${fromDate}&to_date=${toDate}`;
  }
  if(!_.isEmpty(filter) && !isEmpty(filter.invoiceAmountFilter)){
    url = `${url}&invoice_amount_filter=${filter.invoiceAmountFilter}`;
  }
  if(!_.isEmpty(filter) && !isEmpty(filter.reportDate)){
    const reportDate = moment(filter.reportDate).format("YYYY-MM-DD");
    url = `${url}&report_date=${reportDate}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.report_filter_by)) {
    url = `${url}&report_filter_by=${filter.report_filter_by}`;
  }
  if(!_.isEmpty(filter) && !isEmpty(filter.viewType)){
    url = `${url}&view_type=${filter.viewType}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.approvalDate)) {
    url = `${url}&approval_date=${filter.approvalDate}`;
  }
  if(!_.isEmpty(filter) && !isEmpty(filter.viewType) && filter.viewType === "SUMMARY"){
    url = `${url}&is_check_info=${filter.is_check_info}`;
  }
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      agingReports: "aging_reports",
      pagination: "pagination.pagination",
    },
  });
}
export function fetchCollectionReports(
  page = 1,
  perPage = AppConfig.perPage,
  wh_id,
  searchText = "",
  filter = {}
) {
  const org_id = userStore.getStateValue("selectedOrg");
  let url = ApiUrl(
    `v2/reports/get_aging_report_based_on_age?organization_id=${org_id}&${PageParams(
      page,
      perPage
    )}`
  );

  if (filter.isExporting) {
    url = `${url}&is_exporting=true`;
  }

  if (!isEmpty(searchText)) {
    url = `${url}&search_text=${searchText}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.sortBy) && !isEmpty(filter.sortByType)) {
    url = `${url}&sort_by=${filter.sortBy}&sort_order=${I18n.t(`general.sort_${filter.sortByType}`)}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.accountCodes) && filter.accountCodes.length > 0) {
    url = `${url}&account_ids=${filter.accountCodes}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.warehouseIds) && filter.warehouseIds.length > 0) {
    url = `${url}&wh_location_id=${filter.warehouseIds}`;
  }

  // Age Filter
  if (!_.isEmpty(filter.ageFilter)) {
    switch (filter.ageFilter) {
      case "BETWEEN":
        url = `${url}&from_age=${filter.fromAge !== null ? Number(filter.fromAge) : 0}&to_age=${filter.toAge !== null ? Number(filter.toAge) : 30}`;
        break;
      case "GREATER_THAN_EQUAL":
        url = `${url}&age_gte=${filter.ageGte !== null ? Number(filter.ageGte) : 0}`;
        break;
      case "LESS_THAN_EQUAL":
        url = `${url}&age_lte=${filter.ageLte !== null ? Number(filter.ageLte) : 30}`;
        break;
      default:
        url = `${url}&from_age=0&to_age=30`;
        break;
    }
  } else {
    url = `${url}&from_age=0&to_age=30`;
  }

  if (!_.isEmpty(filter.reportDate)) {
    const reportDate = moment(filter.reportDate).format("YYYY-MM-DD");
    url = `${url}&report_date=${reportDate}`;
  }

  if (!_.isEmpty(filter.invoiceAmountFilter)) {
    url = `${url}&invoice_amount_filter=${filter.invoiceAmountFilter}`;
  }

  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      collectionReports: "reports",
      pagination: "pagination.pagination",
      pdf: "pdf",
    },
  });
}



export function fetchAccountAgingReports(
  data,
  page = 1,
  perPage = AppConfig.perPage
) {
  const url = ApiUrl(
    `v2/billing_aging_reports/get_account_aging_reports?${Object.keys(data)
      .map((key) => `${key}=${data[key]}`)
      .join("&")}&${PageParams(page, perPage)}`
  );
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      accountAgingReports: "account_reports",
      pagination: "pagination.pagination",
    },
  });
}

export function fetchSalesPersonReportSummaryView(
  organization_id,
  page = 1,
  perPage = AppConfig.perPage,
  from_date,
  to_date,
  commission,
  view_as
) {
  let url = ApiUrl(
    `v2/sales_commission_report?organization_id=${organization_id}&${PageParams(page, perPage)}`
  );
  if(!_.isEmpty(from_date)){
    const fromDate = moment(from_date).format("YYYY-MM-DD");
    url = `${url}&from_date=${fromDate}`;
  }
  if(!_.isEmpty(to_date)){
    const toDate = moment(to_date).format("YYYY-MM-DD");
    url = `${url}&to_date=${toDate}`;
  }
  if(!_.isEmpty(commission)){
    url = `${url}&is_commission_paid=${commission}`;
  }
  if(!_.isEmpty(view_as)){
    url = `${url}&view_as=${view_as}`;
  }
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      sales_persons: "Invoices",
      pagination: "meta.pagination",
    },
  });
}

export function fetchSalesPersonDetailedReports(
  sales_person_id,
  organization_id,
  commission_status,
  filtered_commission_status,
  page = 1,
  perPage = AppConfig.perPage,
  fromDate,
  toDate,
  is_commission_paid,
  viewAs
) {
  const fromDates = moment(fromDate).format("YYYY-MM-DD");
  const toDates = moment(toDate).format("YYYY-MM-DD");
  const  url = ApiUrl(
    `v2/sales_commission_report/sale_commission_report_orders?sales_person_id=${sales_person_id}&organization_id=${organization_id}&commission_status=${commission_status}&filtered_commission_status=${filtered_commission_status}&is_commission_paid=${is_commission_paid}&from_date=${fromDates}&to_date=${toDates}&view_as=${viewAs}&${PageParams(page, perPage)}`
  );
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      accountAgingReports: "sales_person_invoices",
      pagination: "meta.pagination",
    },
  });
}

export function salesPersonReportExport (page =1, perPage ='', commission_status,isExport,organization_id,download_as,fromDate,toDate) {  
      const fromDates = moment(fromDate).format("YYYY-MM-DD");
      const toDates = moment(toDate).format("YYYY-MM-DD");
      const url = ApiUrl( download_as === "PDF" ? 
        `v2/sales_commission_report?${PageParams(
          page,
          perPage
        )}&is_commission_paid=${commission_status}&is_export=${isExport}&organization_id=${organization_id}&download_as=${download_as}&from_date=${fromDates}&to_date=${toDates}`
        : `v2/sales_commission_report/sale_commission_report_orders?${PageParams(
          page,
          perPage
        )}&is_commission_paid=${commission_status}&is_export=${isExport}&organization_id=${organization_id}&download_as=${download_as}&from_date=${fromDates}&to_date=${toDates}`
      )
      if(isExport){
          return Call('get', url, {}, ParseGeneralResponse, {
              responseDataKeys: { file: 'file', fileName: "filename",pdfResponse : "sales_commission_report"},
          })
      }
    }

export function updateSalesPersonCommissionStatus(data) {
  const url = ApiUrl(`v2/sales_commission_report/update_commission_status`);
  const method = 'post';
  return Call(method, url, data, ParseGeneralResponse, { responseDataKeys: {  sales_commission_report: 'sales_commission_report' } });
}

export function fetchAccountCollectionReports(
  page = 1,
  perPage = AppConfig.perPage,
  filter = {}
) {
  const org_id = userStore.getStateValue("selectedOrg");
  let url = ApiUrl(
    `v2/reports/get_account_aging_report_based_on_age?organization_id=${org_id}&${PageParams(
      page,
      perPage
    )}`
  );

  if (!_.isEmpty(filter.isExporting)) {
    url = `${url}&is_exporting=true`;
  }

  if (!_.isEmpty(filter.searchText)) {
    url = `${url}&search_text=${filter.searchText}`;
  }

  if (!_.isEmpty(filter.sortBy) && !_.isEmpty(filter.sortByType)) {
    url = `${url}&sort_by=${filter.sortBy}&sort_order=${I18n.t(`general.sort_${filter.sortByType}`)}`;
  }

  if (!_.isEmpty(filter.accountCodes)) {
    url = `${url}&account_ids=${filter.accountCodes}`;
  }

  if (!_.isEmpty(filter.warehouseIds)) {
    url = `${url}&wh_location_id=${filter.warehouseIds}`;
  }

  // Age Filter
  if (!_.isEmpty(filter.ageFilter)) {
    switch (filter.ageFilter) {
      case "BETWEEN":
        url = `${url}&from_age=${Number(filter.fromAge) || 0}&to_age=${Number(filter.toAge) || 30}`;
        break;
      case "GREATER_THAN_EQUAL":
        url = `${url}&age_gte=${Number(filter.ageGte) || 0}`;
        break;
      case "LESS_THAN_EQUAL":
        url = `${url}&age_lte=${Number(filter.ageLte) || 30}`;
        break;
      default:
        url = `${url}&from_age=0&to_age=30`;
        break;
    }
  } else {
    url = `${url}&from_age=0&to_age=30`;
  }

  if (!_.isEmpty(filter.reportDate)) {
    const reportDate = moment(filter.reportDate).format("YYYY-MM-DD");
    url = `${url}&report_date=${reportDate}`;
  }

  if (!_.isEmpty(filter.invoiceAmountFilter)) {
    url = `${url}&invoice_amount_filter=${filter.invoiceAmountFilter}`;
  }

  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      accountAgingReports: "reports",
      pagination: "pagination.pagination",
    },
  });
}




export function exportAgingFile(data) {
  const {
    exportEmail = [],
    filter,
    file_type,
    organization_id,
  } = data;
  const {
    warehouseIds,
    accountCodes,
    reportDate,
    viewType = "DETAILS",
    invoiceAmountFilter = "BOTH",
    approvalDate = "",
    is_check_info = false
  } = filter;

  const formattedReportDate = reportDate
    ? reportDate.format("YYYY-MM-DD")
    : null;

  let url = ApiUrl(`v2/billing_aging_reports/get_aging_reports?organization_id=${organization_id}&is_export=${true}&download_as=${file_type}&report_date=${formattedReportDate}&view_type=${viewType}`)
  if(warehouseIds?.length){
    url= `${url}&wh_location_id=${warehouseIds.join(',')}`
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.report_filter_by)) {
    url = `${url}&report_filter_by=${filter.report_filter_by}`;
  }
  if (accountCodes?.length) {
    url = `${url}&account_ids=${accountCodes.join(",")}`;
  }
  if(invoiceAmountFilter){
    url= `${url}&invoice_amount_filter=${invoiceAmountFilter}`
  }
  if(exportEmail){
    url= `${url}&emails=${exportEmail.join(',')}`
  }
  if (!_.isEmpty(approvalDate)) {
    url = `${url}&approval_date=${filter.approvalDate}`;
  }

  if(!_.isEmpty(filter) && !isEmpty(filter.viewType) && filter.viewType === "SUMMARY"){
    url = `${url}&is_check_info=${is_check_info}`;
  }

  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      file: "aging_report",
      data:""
    },
  });
}

export function exportAgingFileAsEmail(payload) {
  const {
    organization_id,
    page,
    per_page,
    sort_by = "none",
    sort_order = "DESC",
    from_date,
    to_date,
    invoice_amount_filter,
    report_date,
    current_role,
    warehouse_ids,
    emails,
    download_as = 'excel'
  } = payload;
  let url = ApiUrl(`v2/billing_aging_reports/get_aging_reports?organization_id=${organization_id}&page=${page}&per_page=${per_page}&sort_by=${sort_by}&sort_order=${sort_order}&warehouse_ids=${warehouse_ids}&from_date=${from_date}&to_date=${to_date}&invoice_amount_filter=${invoice_amount_filter}&report_date=${report_date}&emails=${emails}&current_role=${current_role}&download_as=${download_as}`);

  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      file: "aging_report_email",
      data: "",
    },
  });
}

export function getStatusReport(data) {
  const formData = setObjectToFormData(data);
  const url = ApiUrl(`v2/customer_orders/export_order_statuses_from_csv`);
  return Call("POST", url, formData, ParseGeneralResponse, {
    responseDataKeys: {
      orders: "data",
      pagination: "meta.pagination",
      file: "file",
      fileName: "filename"
    },
  });
}
export function exportStatusReport(data) {
  let url = ApiUrl(
    `v2/customer_orders/export_unprocessed_orders?`
  );

  const queryString = buildQueryString(data, false);
  if (!isEmpty(queryString)) {
    url = `${url}&${queryString}`;
  }
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      orders: "data",
      file: "",
      pagination: "meta.pagination",
    },
  });
}

export function fetchDunningReport(data) {
  const url = ApiUrl(`v2/billing_aging_reports/get_dunning_notice`);

  return Call("post", url, data, ParseGeneralResponse, {
    responseDataKeys: {
      reports_data: "invoice_details",
      pagination: "pagination",
      dunning_notice_report: "dunning_notice_report",
      file: "file",
      fileName: "filename",
      balanceAmount: "balance_amount",
      totalAmount: "total_amount",
      message: "message",
    },
  });
}

export function fetchDunningSummaryReport(data) {
  let url = ApiUrl(`v2/billing_aging_reports/get_dunning_notice_summary`);

  const queryString = buildQueryString(data);
  if (!isEmpty(queryString)) {
    url = `${url}?${queryString}`;
  }
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      reports_data: "invoice_details",
      pagination: "pagination",
      dunning_notice_report: "dunning_notice_report",
      file: 'file',
      fileName: 'filename',
      balanceAmount: 'balance_amount',
      totalAmount: 'total_amount',
      message: 'message'
    },
  });
}

export function exportDunningNotice(data) {
  // const formData = setObjectToFormData(data);
  let url = ApiUrl(
    `v2/billing_aging_reports/export_dunning_notice?${buildQueryString(data)}`
  );
  return Call("GET", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      file: "dunning_notice_report",
    },
  });
}


export function fetchInvoiceStatusReport (data) {
  let url = ApiUrl(`v2/account_invoices/edi_invoice_status_report?`);

  const queryString = buildQueryString(data, false);
  if (!isEmpty(queryString)) {
    url = `${url}&${queryString}`;
  }
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      reports_data: "edi_invoice_status_report",
      pagination: "pagination.pagination",
    },
  });
}

export function fetchQbReport(data) {
  let url = ApiUrl(`v2/account_invoices/get_approved_invoices_with_qb_status?`);

  const queryString = buildQueryString(data, false);
  if (!isEmpty(queryString)) {
    url = `${url}&${queryString}`;
  }
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      reports_data: "order_invoices",
      pagination: "meta.pagination",
      feAmount: "total_frequency_invoice_amount",
      qbAmount: "total_qb_amount",
    },
  });
}

export function fetchOrderWiseReport(data) {
  let url = ApiUrl(`v2/ds_rate_sheets/rate_sheet_gross_orders_index?`);

  const queryString = buildQueryString(data, false);
  if (!isEmpty(queryString)) {
    url = `${url}&${queryString}`;
  }
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      reportsData: "rs_gross_orders",
      pagination: "pagination.pagination",
    },
  });
}
export function sendOrderWiseSettlemet(data, preplan_id) {
  const method = "POST";
  const url = ApiUrl(`v2/ds_rate_sheets/create_rate_sheet_settlements`);
  return Call(method, url, data, ParseGeneralResponse, {
    responseDataKeys: {},
  });
}
export function fetchPendingOrders(data) {
  let url = ApiUrl(`v2/ds_rate_sheets/get_rate_sheet_gross_order_report?`);

  const queryString = buildQueryString(data, false);
  if (!isEmpty(queryString)) {
    url = `${url}&${queryString}`;
  }
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      file: "file",
      fileName: "file_name",
      pendingInvoices: "rate_sheet_gross_order_reports",
      pagination: "pagination.pagination",
    },
  });
}

export function fetchFailedSettlements(data) {
  let url = ApiUrl(`v2/ds_rate_sheets/get_driver_failed_settlements?`);

  const queryString = buildQueryString(data, false);
  if (!isEmpty(queryString)) {
    url = `${url}&${queryString}`;
  }
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      failedSettlements: "failed_settlements",
      pagination: "pagination.pagination",
    },
  });
}

export const  getPodForOrder=(data)=>{
  let url = ApiUrl(`v2/ds_rate_sheets/get_pod_urls`);

  const { organization_id = "", customer_order_id = "" } = data;
  url = `${url}?organization_id=${organization_id}&customer_order_id=${customer_order_id}`;

  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {pod_url:"pod_url"},
  });
}

export function approveOrders(data) {
  let url = ApiUrl(`v2/ds_rate_sheets/approve_rate_sheet_gross_order_report`);

  return Call("put", url, data, ParseGeneralResponse, {
    responseDataKeys: {
      message: "message",
      error: "error"
    }
  });
}

export function restoreFailedSettlements(data) {
  let url = ApiUrl(`v2/ds_rate_sheets/trigger_failed_settlements`);

  return Call("post", url, data, ParseGeneralResponse, {
    responseDataKeys: {
      message: "message",
      error: "error"
    }
  });
}

export function updateAmountPerDay(data) {
  let url = ApiUrl(`v2/ds_rate_sheets/update_driver_per_day_amount`);

  return Call("put", url, data, ParseGeneralResponse, {
    responseDataKeys: {
      message: "message",
      error: "error"
    }
  });
}


export function deletePendingInvoice(data) {
  let url = ApiUrl(`v2/ds_rate_sheets/delete_driver_report`);

  const { organization_id = "", rate_sheet_gross_order_report_id = "" } = data;
  url = `${url}?organization_id=${organization_id}&rate_sheet_gross_order_report_id=${rate_sheet_gross_order_report_id}`;


  return Call("delete", url, data, ParseGeneralResponse, {
    responseDataKeys: {
      message: "message",
      error: "error"
    }
  });
}

export function fetchUnappliedFundsReport(data) {
  const {
    page = 1,
    perPage = AppConfig.perPage,
    organization_id,
    from_date = "",
    to_date = "",
    search_value = "",
    is_export = false,
    account_ids = []
  } = data;

  let url = ApiUrl(
    `v2/billing_aging_reports/ar_unapplied_fund_report?${PageParams(
      page,
      perPage
    )}&organization_id=${organization_id}`
  );

  if (isEmpty(search_value)) {
    url += `&account_ids=${account_ids}`;
  }

  if (!isEmpty(from_date)) {
    url += `&from_date=${from_date}`;
  }

  if (!isEmpty(to_date)) {
    url += `&to_date=${to_date}`;
  }

  if (!isEmpty(search_value)) {
    url += `&search_value=${encodeURIComponent(search_value)}`;
  }

  let exportUrl = `${url}&is_export=${true}`;

  return Call("get", is_export ? exportUrl : url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      reports_data: "reports",
      file: "file",
      pagination: "pagination.pagination",
    },
  });
}
//new Aging report API
export function fetchAgingReportsPlus(
  page = 1,
  perPage = AppConfig.perPage,
  wh_id,
  searchText = "",
  filter = {}
) {
  const org_id = userStore.getStateValue("selectedOrg");
  let url = ApiUrl(
    `v2/billing_aging_reports/aging_reports_service?organization_id=${org_id}&is_export=${false}&${PageParams(
      page,
      perPage
    )}`
  );
  if (!isEmpty(searchText)) {
    url = `${url}&search_value=${searchText}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.sortBy) && !isEmpty(filter.sortByType)) {
    url = `${url}&sort_by=${filter.sortBy}&sort_order=${I18n.t(`general.sort_${filter.sortByType}`)}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.accountCodes) && filter.accountCodes.length > 0) {
    url = `${url}&account_ids=${filter.accountCodes}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.warehouseIds) && filter.warehouseIds.length > 0 && isEmpty(searchText)) {
    url = `${url}&wh_location_id=${filter.warehouseIds}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.fromDate) && !isEmpty(filter.toDate)) {
    const fromDate = moment(filter.fromDate).format("YYYY-MM-DD");
    const toDate = moment(filter.toDate).format("YYYY-MM-DD")
    url = `${url}&from_date=${fromDate}&to_date=${toDate}`;
  }
  if(!_.isEmpty(filter) && !isEmpty(filter.invoiceAmountFilter)){
    url = `${url}&invoice_amount_filter=${filter.invoiceAmountFilter}`;
  }
  if(!_.isEmpty(filter) && !isEmpty(filter.reportDate)){
    const reportDate = moment(filter.reportDate).format("YYYY-MM-DD");
    url = `${url}&report_date=${reportDate}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.report_filter_by)) {
    url = `${url}&report_filter_by=${filter.report_filter_by}`;
  }
  if(!_.isEmpty(filter) && !isEmpty(filter.viewType)){
    url = `${url}&view_type=${filter.viewType}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.approvalDate)) {
    url = `${url}&approval_date=${filter.approvalDate}`;
  }
  if(!_.isEmpty(filter) && !isEmpty(filter.viewType) && filter.viewType === "SUMMARY"){
    url = `${url}&is_check_info=${filter.is_check_info}`;
  }
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      agingReports: "aging_reports",
      pagination: "pagination.pagination",
      totals:"totals"
    },
  });
}

// Fetching Expanded Account Aging Report
export function fetchAccountAgingReportPlus(payload = {}) {
  const {
    page = 1,
    perPage = AppConfig.perPage,
    searchText = "",
    filter = {},
    account_id
  } = payload;

  const orgId = userStore.getStateValue("selectedOrg");
  
  const params = new URLSearchParams({
    organization_id: orgId,
    is_export: false,
    page: page,
    per_page: perPage
  });

  const addParam = (key, value) => {
    if (!isEmpty(value)) params.append(key, value);
  };

  // Search
  addParam("search_value", searchText);

  // Sorting
  if (filter.sortBy && filter.sortByType) {
    addParam("sort_by", filter.sortBy);
    addParam("sort_order", I18n.t(`general.sort_${filter.sortByType}`));
  }

  // Account filter
  if (!isEmpty(account_id)) {
    addParam("account_ids", account_id);
  }

  // Warehouse filter (only when no search text)
  if (filter.warehouseIds?.length && isEmpty(searchText)) {
    addParam("wh_location_id", filter.warehouseIds);
  }

  // Date range
  if (filter.fromDate && filter.toDate) {
    addParam("from_date", moment(filter.fromDate).format("YYYY-MM-DD"));
    addParam("to_date", moment(filter.toDate).format("YYYY-MM-DD"));
  }

  // Invoice amount filter
  addParam("invoice_amount_filter", filter.invoiceAmountFilter);

  // Report date
  if (filter.reportDate) {
    addParam("report_date", moment(filter.reportDate).format("YYYY-MM-DD"));
  }

  // Report filter by
  addParam("report_filter_by", filter.report_filter_by);

  // View type
  addParam("view_type", "INVOICE");

  // Approval date
  addParam("approval_date", filter.approvalDate);

  // Summary specific flag
  if (filter.is_check_info) {
    addParam("is_check_info", filter.is_check_info);
  }

  const url = ApiUrl(
    `v2/billing_aging_reports/aging_reports_service?${params.toString()}`
  );

  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      agingReports: "aging_reports",
      pagination: "pagination.pagination",
    },
  });
}

//new export aging report API
export function exportAgingFilePlus(data) {
  const {
    exportEmail = [],
    filter,
    file_type,
    organization_id,
  } = data;
  const {
    warehouseIds,
    accountCodes,
    reportDate,
    viewType = "DETAILS",
    invoiceAmountFilter = "BOTH",
    approvalDate = "",
    is_check_info = false
  } = filter;

  const formattedReportDate = reportDate
    ? reportDate.format("YYYY-MM-DD")
    : null;

  let url = ApiUrl(`v2/billing_aging_reports/aging_reports_service?organization_id=${organization_id}&is_export=${true}&download_as=${file_type}&report_date=${formattedReportDate}&view_type=${viewType}`)
  if(warehouseIds?.length){
    url= `${url}&wh_location_id=${warehouseIds.join(',')}`
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.report_filter_by)) {
    url = `${url}&report_filter_by=${filter.report_filter_by}`;
  }
  if (accountCodes?.length) {
    url = `${url}&account_ids=${accountCodes.join(",")}`;
  }
  if(invoiceAmountFilter){
    url= `${url}&invoice_amount_filter=${invoiceAmountFilter}`
  }
  if(exportEmail){
    url= `${url}&emails=${exportEmail.join(',')}`
  }
  if (!_.isEmpty(approvalDate)) {
    url = `${url}&approval_date=${filter.approvalDate}`;
  }

  if(!_.isEmpty(filter) && !isEmpty(filter.viewType) && filter.viewType === "SUMMARY"){
    url = `${url}&is_check_info=${is_check_info}`;
  }

  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      file: "aging_report",
      data:""
    },
  });
}
//Split Revenue Api
export function fetchSplitRevenueReport(data) {
  const {
    page = 1,
    perPage = AppConfig.perPage,
    organization_id,
    warehouse_ids = [],
    classificationType = [],
    from_date = "",
    to_date = "",
    approvalDate = "",
    search_token = "",
    is_export = false,
  } = data;

  let url = ApiUrl(
    `v2/billing_aging_reports/classification_reports?${PageParams(
      page,
      perPage,
    )}&organization_id=${organization_id}`,
  );

  if (!isEmpty(warehouse_ids) && warehouse_ids.length > 0) {
    url += `&warehouse_ids=${warehouse_ids}`;
  }

  if (!isEmpty(classificationType) && classificationType.length > 0) {
    url += `&classification_type=${classificationType.join(", ")}`;
  }

  if (!isEmpty(from_date)) {
    url += `&from_date=${from_date}`;
  }

  if (!isEmpty(to_date)) {
    url += `&to_date=${to_date}`;
  }

  if (!isEmpty(approvalDate)) {
    url += `&approval_date=${approvalDate}`;
  }
  if (!isEmpty(search_token)) {
    url += `&search_value=${encodeURIComponent(search_token)}`;
  }
  if (is_export) {
    url += `&is_export=true`;
  }

  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      reportData: "classification_reports",
      pagination: "pagination.pagination",
      file: "file",
    },
  });
}

//Accessorial Report API
export function fetchAccessorialsList(data) {
  const { organization_id } = data

  let url = ApiUrl(`v2/account_accessorials/get_organization_accessorial_list?organization_id=${organization_id}`);

  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      accessorialData: "data",
    },
  });
}

export function fetchAccessorialReport(data) {
  const {
    page = 1,
    perPage = AppConfig.perPage,
    organization_id,
    warehouse_ids = [],  
    from_date,
    to_date,
    filtered_by,
    accessorial_names = [],
    invoice_status = "ALL",
    is_export = false
  } = data;

  const url = ApiUrl(`v2/account_accessorials/rate_sheet_accessorial_report`);

  const payload = {
    page,
    per_page: perPage,
    organization_id,
    warehouse_ids,
    from_date,
    to_date,
    filtered_by,
    accessorial_names,
    invoice_status: invoice_status === "ALL" ? "" : invoice_status,
    is_export
  };

  return Call("post", url, payload, ParseGeneralResponse, {
    responseDataKeys: {
      reportData: "data",
      pagination: "pagination.pagination",
      file: "excel_file",
    },
  });
}    

//Monthly Revenue Report API
export function fetchMonthlyRevenueReport(data) {
  const {
    page = 1,
    perPage = AppConfig.perPage,
    organization_id,
    warehouse_ids=[],
    account_ids=[],
    date_type,
    from_date,
    to_date,
    export_as = ""
  } = data;

  let url = ApiUrl(
    `v2/billing_aging_reports/yearly_revenue_report?${PageParams(
      page,
      perPage
    )}&organization_id=${organization_id}&account_ids=${account_ids}`
  );

  if (!isEmpty(warehouse_ids) && warehouse_ids.length > 0) {
    url += `&warehouse_ids=${warehouse_ids}`;
  }

  if (!isEmpty(from_date)) {
    url += `&from_date=${from_date}`;
  }

  if (!isEmpty(to_date)) {
    url += `&to_date=${to_date}`;
  }

  if(!isEmpty(date_type)){
    url += `&date_type=${date_type}`;
  }

  let exportUrl = `${url}&export_as=${export_as}`;

  return Call("get", !isEmpty(export_as) ? exportUrl : url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      reportData: "report.account_wise",
      reportsTotal: "report.monthly_totals",
      grandTotal: "report.grand_total",
      pagination: "pagination.pagination",
      file: "file",
      fileName: "filename"
    },
  });
}   

// New Special settlement
export function fetchUnsettledOrdersList(data) {
  const {
    warehouse_ids = [],
    driver_id = "",
    filter_by = "",
    from_date = "",
    to_date = "",
    organization_id,
    wh_time_zone,
    filter_amount,
    show_amount,
    search_value
  } = data;

  let url = ApiUrl(
    `v2/driver_settlement_wise_views/unsettled_orders_list?organization_id=${organization_id}&filter_by=${filter_by}&warehouse_ids=${warehouse_ids}&driver_id=${driver_id}&wh_time_zone=${wh_time_zone}&filter_amount=${filter_amount}`
  );

  if (!isEmpty(from_date)) {
    url += `&from_date=${from_date}`;
  }

  if (!isEmpty(to_date)) {
    url += `&to_date=${to_date}`;
  }

  if(!isEmpty(show_amount)){
    url += `&show_amount=${show_amount}`
  }
  
  if(!isEmpty(search_value)){
    url += `&search_value=${encodeURIComponent(search_value)}`
  }

  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      unsettledOrders: "unsettled_orders_list",
    },
  });
}

export function fetchDriverPayReports(data) {
  const { warehouse_ids = [], driver_id = "", organization_id, page, perPage, status } = data;
  const url = ApiUrl(
    `v2/driver_settlement_wise_views/fetch_driver_pay_reports?${PageParams(
      page,
      perPage
    )}&organization_id=${organization_id}&driver_id=${driver_id}&warehouse_ids=${warehouse_ids}&status=${status}`
  );
  const method = "get";
  return Call(method, url, {}, ParseGeneralResponse, {
    responseDataKeys: {
      driverPayReports: "driver_pay_reports",
      totalCount: "total_count"
    },
  });
}
export function createSettlement(data) {
  const url = ApiUrl(`v2/driver_settlement_wise_views/add_gross_order_ids_to_driver_pay_report`);
  const method = "POST";
  return Call(method, url, data, ParseGeneralResponse, { responseDataKeys: {  message: 'message', driver_pay_report_id: "driver_pay_report_id" } });
} 

export function deleteSettlement(data) {
  const { organization_id, driver_pay_report_id = "", grossReportOrderIds = [] } = data;
  let url = ApiUrl(`v2/driver_settlement_wise_views/remove_order_settlements`);
  const method = "DELETE";
  return Call("delete", url, data, ParseGeneralResponse, {
    responseDataKeys: { message: "message" },
  });
}

export function exportSpecificSettlement(data) {
  const url = ApiUrl(
    `v2/driver_settlement_wise_views/generate_driver_pay_report_export`
  );

  return Call("post", url, data, ParseGeneralResponse, {
    responseDataKeys: {
      file: "report",
    },
  });
}
export function createIndividualSettlement(data) {
  const url = ApiUrl(`v2/driver_settlement_wise_views/create_empty_settlement`);
  const method = "POST";
  return Call(method, url, data, ParseGeneralResponse, { responseDataKeys: {  message: 'message', driver_pay_report_id: "driver_pay_report_id" } });
} 
